<template>
   <div class="view-page">
      <h1 v-if="showSpin">Downloading...</h1>
      <h1 v-else>Download is complete!</h1>
      <p v-if="showSpin">Your file download has begun and should be available shortly...</p>
      <p v-if="showSpin"><i class="fas fa-spinner fa-spin ml-orange fa-lg"></i></p>
   </div>
</template>
   
<script>
export default {
   name: "ViewSchedule",
   data() {
      return {
         showSpin: true,
      };
   },
   async mounted() {
      if (!this.$route.params.pth || this.$route.params.pth == "") {
         this.$router.push({ name: 'welcome' }).catch((f) => {});
         return
      }
      await this.openDoc(this.$route.params.pth);
   },
   methods: {
      async openDoc(path) {
         let title = "CommissionSchedule.pdf";
         let payload = {
            AppUserId: '2C85F961-92F0-4C84-B4A9-147E932B4AB2',
            DownloadFileType: 3, // External Schedule
            Path: path,
            Title: title,
         };

         this.$document.apiDownload(payload, true).then(
            (r) => {
               this.showSpin = false
               if (this.$document.errors.length > 0) {
                  this.$swal(
                     "Document Unavailable",
                     "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                     "error"
                  );
               } 
            },
            (e) => {
               this.showSpin = false
               this.$swal(
                  "Document Unavailable",
                  "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                  "error"
               );
            }
         );
      },
   }
};
</script>

<style>
.view-page {
   padding: 36px;
   height: 100%;
   min-height: 800px;
}
</style>